import React from 'react'
import { Route, Routes } from "react-router-dom";
import Layout from "../components/Layout";
import Home from "../pages/Home";
import Videos from "../pages/Videos";
import ArticleDetailPage from '../pages/ArticleDetailPage';
import CategoryPage from '../pages/CategoryPage';
import VideojsPlayer from '../pages/LiveTv';
import SearchPage from '../pages/SearchPage';
import BigNews from '../pages/Bignews';
import StateToggle from '../pages/StateToggle';
import Webstory from 'pages/Webstory';
import Gallery from 'pages/Gallery';
import Shorts from 'pages/Shorts';
import StoryDetails from 'pages/StoryDetails';
import GalleryDetails from 'pages/GalleryDetails';
import ContactUs from 'pages/ContactUs';
import AboutUs from 'pages/AboutUs';
import PrivacyPolicy from 'pages/PrivacyPolicy';
import Tnc from 'pages/Tnc';
import Testpage from 'pages/Testpage';
import Login from 'pages/Login';
import LoginLayout from 'components/LoginLayout';
import Aqipage from 'pages/Aqipage';
import Result from 'pages/BiharResult';

export const Authstack = ()=> {
  return (
    <LoginLayout>
        <Routes>          
            <Route path="/login" element={<Login />} />
            </Routes>
            </LoginLayout>
            )
          }
          
export const Appstack = ()=> {
  return (
    <Layout>
        <Routes>
           <Route path="/login" element={<Login />} />       
            <Route path="/" element={<Home />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/livetv" element={<VideojsPlayer />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/bigNews" element={<BigNews />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/shorts" element={<Shorts />} />           
            <Route path="/testpage" element={<Testpage />} />
            <Route path="/settings/contactus" element={<ContactUs />} />
            <Route path="/settings/about-us" element={<AboutUs />} />
            <Route path="/settings/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/settings/tnc" element={<Tnc />} />

            <Route path="/gallery/web-story" element={<Webstory />} />            
            <Route path="/story/:storySlug" element={<StoryDetails />} />            
            <Route path="/photos/:photoSlug" element={<GalleryDetails />} />            
            <Route path="/cat/:stateId?" element={<StateToggle />} />
             <Route path="/news/:slug" element={<ArticleDetailPage />} />
              <Route path="/category/:categoryId" element={<CategoryPage />} />              
              <Route path="/aqi" element={<Aqipage />} />              
              <Route path="/result/bihar" element={<Result />} />
        </Routes>
      </Layout>
  )
}
